import { useMediaQuery, useTheme } from "@mui/material"

export default function useIsXsScreen() {
    const theme = useTheme()

    return useMediaQuery(theme.breakpoints.down("sm")) ? true : false
}
